<section class="tw-py-10 tw-px-4 lg:tw-px-20 tw-bg-[#F9FAFF]">
    <!-- Header with title and filter/sort buttons for mobile -->
    <div class="tw-flex tw-justify-between tw-items-center tw-mb-5 tw-relative">
        <div>
            <p
                class="tw-text-[28px] md:tw-text-[40px] tw-w-full tw-text-[#0F3172] tw-font-bold"
            >
                {{ "NEW_PRODUCTS.PRODUCTS" | translate }}
            </p>
            <p class="tw-text-left tw-text-gray-600 tw-my-10 tw-text-[#1A202C]">
                {{ "NEW_PRODUCTS.PRODUCTS_DESC" | translate }}
            </p>
        </div>
    </div>

    <!-- Begin: Search Bar -->
    <div
        class="tw-flex tw-flex-col md:tw-flex-row tw-mb-5 md:tw-mb-10 tw-gap-2"
    >
        <div
            class="tw-h-[56px] tw-flex tw-flex-1 tw-content-center tw-gap-3 tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-2xl tw-p-[18px] tw-bg-white"
        >
            <mat-icon fontIcon="search" class="tw-text-[#4B6EEC]" />
            <input
                class="tw-flex-1 tw-font-semibold"
                placeholder="{{
                    'NEW_PRODUCTS.SEARCH_FOR_ANY_PRODUCT' | translate
                }}"
                [(ngModel)]="searchInput"
                (keyup)="onSearchProduct(searchInput)"
            />
        </div>
        <div class="tw-hidden md:tw-flex tw-gap-2">
            <!-- Filter Button -->
            <div
                class="filter-container tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-2xl tw-bg-white"
            >
                <button
                    class="tw-h-[56px] tw-px-6 tw-font-bold tw-flex tw-items-center tw-gap-3 tw-text-[#7B7575]"
                    (click)="toggleFilter(!isFilterOpen)"
                >
                    <mat-icon fontIcon="tune" class="tw-text-[22px]" />
                    {{ "NEW_PRODUCTS.FILTER" | translate }}
                </button>
                <div
                    *ngIf="isFilterOpen"
                    class="tw-absolute tw-z-40 tw-mt-2 tw-w-56 tw-origin-top-right tw-divide-y tw-divide-gray-100 tw-rounded-2xl tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none"
                >
                    <div class="tw-py-4 tw-px-5" role="none">
                        <div class="tw-py-1 tw-flex tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                [checked]="checkboxStates['Provider']"
                                (click)="onFilterProduct($event, 'Provider')"
                            />
                            <span class="tw-text-sm tw-font-semibold">
                                {{ "PRODUCT_MATCHING.PROVIDER" | translate }}
                            </span>
                        </div>
                        <div
                            class="tw-pl-6 tw-pb-4 tw-border-b-2 tw-border-gray-200"
                        >
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['BANK']"
                                    (click)="onFilterProduct($event, 'BANK')"
                                />
                                <span class="tw-text-sm tw-font-semibold"
                                    >Banks</span
                                >
                            </div>
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['DIGITAL BANK']"
                                    (click)="
                                        onFilterProduct($event, 'DIGITAL BANK')
                                    "
                                />
                                <span class="tw-text-sm tw-font-semibold"
                                    >Digital Banks</span
                                >
                            </div>
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['P2P']"
                                    (click)="onFilterProduct($event, 'P2P')"
                                />
                                <span class="tw-text-sm tw-font-semibold"
                                    >P2P</span
                                >
                            </div>
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['CGC']"
                                    (click)="onFilterProduct($event, 'CGC')"
                                />
                                <span class="tw-text-sm tw-font-semibold"
                                    >CGC</span
                                >
                            </div>
                        </div>
                        <div class="tw-pb-1 tw-flex tw-pt-4 tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                [checked]="checkboxStates['Type']"
                                (click)="onFilterProduct($event, 'Type')"
                            />
                            <span class="tw-text-sm tw-font-semibold">
                                {{ "PRODUCT_MATCHING.TYPE" | translate }}
                            </span>
                        </div>
                        <div class="tw-pl-6">
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['isIslamic']"
                                    (click)="
                                        onFilterProduct($event, 'isIslamic')
                                    "
                                />
                                <span class="tw-text-sm tw-font-semibold">
                                    {{ "PRODUCT_MATCHING.ISLAMIC" | translate }}
                                </span>
                            </div>
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['isConventional']"
                                    (click)="
                                        onFilterProduct(
                                            $event,
                                            'isConventional'
                                        )
                                    "
                                />
                                <span class="tw-text-sm tw-font-semibold">
                                    {{
                                        "PRODUCT_MATCHING.CONVENTIONAL"
                                            | translate
                                    }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sort By Button -->
            <div
                class="sort-container tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-2xl tw-bg-white"
            >
                <button
                    class="tw-h-[56px] tw-px-6 tw-font-bold tw-flex tw-items-center tw-gap-3 tw-text-[#7B7575]"
                    (click)="toggleSortBy(!isSortbyOpen)"
                >
                    <mat-icon fontIcon="sort" class="tw-text-[22px]" />
                    {{ "NEW_PRODUCTS.SORT_BY" | translate }}
                </button>
                <div
                    *ngIf="isSortbyOpen"
                    class="tw-absolute tw-z-10 tw-overflow-hidden tw-right-0 tw-mt-2 tw-w-72 tw-origin-top-right tw-divide-y tw-divide-gray-100 tw-rounded-2xl tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                    tabindex="-1"
                >
                    <button
                        class="tw-px-6 tw-py-5 tw-w-full tw-text-left"
                        [ngClass]="{
                            'tw-bg-[#4B6EEC] tw-text-white':
                                selectedSortBy === 0
                        }"
                        (click)="onSortProduct(0)"
                    >
                        {{
                            "PRODUCT_MATCHING.INTEREST_RATE_HIGH_LOW"
                                | translate
                        }}
                    </button>
                    <div class="tw-px-4">
                        <hr />
                    </div>
                    <button
                        class="tw-px-6 tw-py-5 tw-w-full tw-text-left"
                        [ngClass]="{
                            'tw-bg-[#4B6EEC] tw-text-white':
                                selectedSortBy === 1
                        }"
                        (click)="onSortProduct(1)"
                    >
                        {{
                            "PRODUCT_MATCHING.INTEREST_RATE_LOW_HIGH"
                                | translate
                        }}
                    </button>
                    <div class="tw-px-4">
                        <hr />
                    </div>
                    <button
                        class="tw-px-6 tw-py-5 tw-w-full tw-text-left"
                        [ngClass]="{
                            'tw-bg-[#4B6EEC] tw-text-white':
                                selectedSortBy === 2
                        }"
                        (click)="onSortProduct(2)"
                    >
                        {{ "PRODUCT_MATCHING.PROCESSING_HIGH_LOW" | translate }}
                    </button>
                    <div class="tw-px-4">
                        <hr />
                    </div>
                    <button
                        class="tw-px-6 tw-py-5 tw-w-full tw-text-left"
                        [ngClass]="{
                            'tw-bg-[#4B6EEC] tw-text-white':
                                selectedSortBy === 3
                        }"
                        (click)="onSortProduct(3)"
                    >
                        {{ "PRODUCT_MATCHING.PROCESSING_LOW_HIGH" | translate }}
                    </button>
                </div>
            </div>
        </div>
        <button
            [attr.ga-event-id]="ga_event[0].calculateFinancing.id"
            [attr.ga-event-category]="ga_event[0].category"
            ga-event-label="Calculate My Financing Button Click"
            ga-track="track"
            (click)="calculateFinancing()"
            class="tw-hidden md:tw-flex tw-bg-[#003A70] tw-text-white tw-px-6 tw-py-3 tw-rounded-full tw-font-medium hover:tw-bg-[#003A70] tw-items-center tw-gap-2"
        >
            <img
                src="/assets/images/icons/Calculator-white.png"
                class="tw-h-5 tw-w-auto"
                alt="Calculate"
            />
            {{ "NEW_PRODUCTS.CALCULATE_MY_FINANCING" | translate }}
        </button>
    </div>

    <!-- Mobile eligibility button -->
    <div
        class="md:tw-hidden tw-flex tw-justify-between tw-mb-5 tw-items-center"
    >
        <button
            [attr.ga-event-id]="ga_event[0].calculateFinancing.id"
            [attr.ga-event-category]="ga_event[0].category"
            ga-event-label="Calculate My Financing Button Click"
            ga-track="track"
            (click)="calculateFinancing()"
            class="tw-bg-[#003A70] tw-text-white tw-px-6 tw-py-4 tw-rounded-full tw-font-medium hover:tw-[#003A70] tw-flex tw-items-center tw-justify-center tw-gap-2"
        >
            <img
                src="/assets/images/icons/Calculator-white.png"
                class="tw-h-5 tw-w-auto"
                alt="Calculate"
            />
            {{ "NEW_PRODUCTS.CALCULATE_MY_FINANCING" | translate }}
        </button>
        <div class="md:tw-hidden tw-flex tw-gap-2 tw-relative">
            <div class="tw-relative">
                <button
                    (click)="toggleFilterMobile()"
                    class="tw-bg-white tw-h-10 tw-w-10 tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-md tw-flex tw-items-center tw-justify-center"
                >
                    <mat-icon fontIcon="tune" class="tw-text-[22px]" />
                </button>
                <!-- Filter dropdown for mobile -->
                <div
                    *ngIf="isFilterOpenMobile"
                    class="filter-container-mobile md:tw-hidden tw-absolute tw-z-10 tw-top-12 tw-right-0 tw-w-56 tw-origin-top-right tw-divide-y tw-divide-gray-100 tw-rounded-2xl tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none"
                >
                    <div class="tw-py-4 tw-px-5" role="none">
                        <div class="tw-py-1 tw-flex tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                [checked]="checkboxStates['Provider']"
                                (click)="onFilterProduct($event, 'Provider')"
                            />
                            <span class="tw-text-sm tw-font-semibold">{{
                                "PRODUCT_MATCHING.PROVIDER" | translate
                            }}</span>
                        </div>
                        <div
                            class="tw-pl-6 tw-pb-4 tw-border-b-2 tw-border-gray-200"
                        >
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['BANK']"
                                    (click)="onFilterProduct($event, 'BANK')"
                                />
                                <span class="tw-text-sm tw-font-semibold"
                                    >Banks</span
                                >
                            </div>
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['P2P']"
                                    (click)="onFilterProduct($event, 'P2P')"
                                />
                                <span class="tw-text-sm tw-font-semibold"
                                    >P2P</span
                                >
                            </div>
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['CGC']"
                                    (click)="onFilterProduct($event, 'CGC')"
                                />
                                <span class="tw-text-sm tw-font-semibold"
                                    >CGC</span
                                >
                            </div>
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['DIGITAL BANK']"
                                    (click)="
                                        onFilterProduct($event, 'DIGITAL BANK')
                                    "
                                />
                                <span class="tw-text-sm tw-font-semibold"
                                    >Digital Banks</span
                                >
                            </div>
                        </div>
                        <div class="tw-pb-1 tw-flex tw-pt-4 tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                [checked]="checkboxStates['Type']"
                                (click)="onFilterProduct($event, 'Type')"
                            />
                            <span class="tw-text-sm tw-font-semibold">{{
                                "PRODUCT_MATCHING.TYPE" | translate
                            }}</span>
                        </div>
                        <div class="tw-pl-6">
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['isIslamic']"
                                    (click)="
                                        onFilterProduct($event, 'isIslamic')
                                    "
                                />
                                <span class="tw-text-sm tw-font-semibold">{{
                                    "PRODUCT_MATCHING.ISLAMIC" | translate
                                }}</span>
                            </div>
                            <div class="tw-py-1 tw-flex tw-items-center">
                                <input
                                    type="checkbox"
                                    class="tw-w-4 tw-h-4 show-cursor tw-mr-2"
                                    [checked]="checkboxStates['isConventional']"
                                    (click)="
                                        onFilterProduct(
                                            $event,
                                            'isConventional'
                                        )
                                    "
                                />
                                <span class="tw-text-sm tw-font-semibold">{{
                                    "PRODUCT_MATCHING.CONVENTIONAL" | translate
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw-relative">
                <button
                    (click)="toggleSortMobile()"
                    class="tw-bg-white tw-h-10 tw-w-10 tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-md tw-flex tw-items-center tw-justify-center"
                >
                    <mat-icon fontIcon="sort" class="tw-text-[22px]" />
                </button>
                <!-- Sort dropdown for mobile -->
                <div
                    *ngIf="isSortbyOpenMobile"
                    class="sort-container-mobile md:tw-hidden tw-absolute tw-z-10 tw-top-12 tw-right-0 tw-w-72 tw-origin-top-right tw-divide-y tw-divide-gray-100 tw-rounded-2xl tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none"
                >
                    <button
                        class="tw-px-6 tw-py-5 tw-w-full tw-text-left"
                        [ngClass]="{
                            'tw-bg-[#4B6EEC] tw-text-white':
                                selectedSortBy === 0
                        }"
                        (click)="onSortProduct(0)"
                    >
                        {{
                            "PRODUCT_MATCHING.INTEREST_RATE_HIGH_LOW"
                                | translate
                        }}
                    </button>
                    <div class="tw-px-4">
                        <hr />
                    </div>
                    <button
                        class="tw-px-6 tw-py-5 tw-w-full tw-text-left"
                        [ngClass]="{
                            'tw-bg-[#4B6EEC] tw-text-white':
                                selectedSortBy === 1
                        }"
                        (click)="onSortProduct(1)"
                    >
                        {{
                            "PRODUCT_MATCHING.INTEREST_RATE_LOW_HIGH"
                                | translate
                        }}
                    </button>
                    <div class="tw-px-4">
                        <hr />
                    </div>
                    <button
                        class="tw-px-6 tw-py-5 tw-w-full tw-text-left"
                        [ngClass]="{
                            'tw-bg-[#4B6EEC] tw-text-white':
                                selectedSortBy === 2
                        }"
                        (click)="onSortProduct(2)"
                    >
                        {{ "PRODUCT_MATCHING.PROCESSING_HIGH_LOW" | translate }}
                    </button>
                    <div class="tw-px-4">
                        <hr />
                    </div>
                    <button
                        class="tw-px-6 tw-py-5 tw-w-full tw-text-left"
                        [ngClass]="{
                            'tw-bg-[#4B6EEC] tw-text-white':
                                selectedSortBy === 3
                        }"
                        (click)="onSortProduct(3)"
                    >
                        {{ "PRODUCT_MATCHING.PROCESSING_LOW_HIGH" | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Search Results -->
    <div
        class="tw-text-2xl tw-font-semibold tw-pt-4 tw-pb-3"
        *ngIf="searchInput.length > 0 || hasAnyTrueFlag(checkboxStates)"
    >
        <ng-container
            *ngIf="
                searchedBankAndp2pList > 0 || totalMatchedProducts > 0;
                else noSearchResult
            "
        >
            <ng-container
                *ngIf="searchedBankAndp2pList == 1; else multipleBanks"
            >
                1 {{ "NEW_APPLICATION.RESULT_FOUND" | translate }}
            </ng-container>
            <ng-template #multipleBanks>
                {{ searchedBankAndp2pList }}
                {{ "NEW_APPLICATION.RESULTS_FOUND" | translate }}
            </ng-template>
            <div class="tw-text-base tw-font-semibold tw-text-gray-500">
                {{ "NEW_APPLICATION.BASED_ON_SEARCH" | translate }}
            </div>
        </ng-container>
        <ng-template #noSearchResult>
            <div
                class="tw-text-base tw-font-semibold tw-text-center tw-text-[#003A70]"
            >
                {{ "NEW_APPLICATION.NO_SEARCH_RESULT" | translate }}
            </div>
        </ng-template>
    </div>
    
    <!-- No Results Message for filters without search -->
    <div
        *ngIf="
            !(showBanks && showBanksFiltered && bankProductsList?.length) &&
            !(
                showDigitalBanks &&
                showDigitalBanksFiltered &&
                digitalBankProductsList?.length
            ) &&
            !(
                showAlternateFinancing &&
                showAlternateFinancingFiltered &&
                p2pProductsList?.length
            ) &&
            searchInput.length === 0 &&
            !hasAnyTrueFlag(checkboxStates)
        "
        class="tw-text-base tw-font-semibold tw-text-center tw-text-[#003A70] tw-pt-4 tw-pb-3"
    >
        {{ "NEW_APPLICATION.NO_SEARCH_RESULT" | translate }}
    </div>

    <!-- Banks  blk-->
    <div
        class="tw-mb-10"
        *ngIf="showBanks && showBanksFiltered && bankProductsList?.length"
    >
        <p
            class="tw-text-[20px] md:tw-text-[30px] tw-w-full tw-text-[#0F3172] tw-font-semibold"
        >
            {{ "COMMON.BANKS" | translate }}
        </p>
        <!-- Mobile view with pagination -->
        <div class="md:tw-hidden">
            <div class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 tw-gap-6">
                <ng-container
                    *ngFor="let element of displayedBankProducts; let i = index"
                >
                    <div
                        class="tw-w-full tw-h-[175px] md:tw-h-[224px] tw-p-2 tw-bg-[#C7EBFF3D] tw-shadow-sm tw-border tw-border-[#6D7A873D] tw-rounded-[10px] tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-3 tw-overflow-hidden"
                        [ngClass]="{
                            'tw-border-[#4B6EEC]':
                                clickedProduct?.name ===
                                    element.fiPartnerDescBm &&
                                clickedProduct?.type === 'BANK' &&
                                !dialogClosed,
                            'tw-border-[#D5D5D5]':
                                !(
                                    clickedProduct?.name ===
                                        element.fiPartnerDescBm &&
                                    clickedProduct?.type === 'BANK'
                                ) && dialogClosed
                        }"
                    >
                        <div
                            class="tw-bg-white tw-rounded-[10px] tw-p-2 tw-h-full tw-max-h-[130px] tw-w-full tw-flex tw-justify-center tw-items-center"
                        >
                            <img
                                [attr.ga-event-id]="
                                    element.fiPartnerDescEng +
                                    '_banks_card_msmefinancing_click'
                                "
                                ga-event-category="MSME Financing Button"
                                ga-event-label="Banks Card Click"
                                ga-track="track"
                                [src]="getImgUrl(element?.fiImage)"
                                alt="Banks"
                                class="tw-h-full tw-object-contain"
                            />
                        </div>
                        <button
                            [attr.ga-event-id]="
                                element.fiPartnerDescEng +
                                '_banks_card_msmefinancing_click'
                            "
                            ga-event-category="MSME Financing Button"
                            ga-event-label="Banks Card Click"
                            ga-track="track"
                            (click)="openProducts(element, 'BANK')"
                            class="tw-block tw-mx-auto tw-bg-[#0F3172] tw-text-white tw-rounded-full tw-min-h-[40px] tw-w-full tw-mb-1 md:tw-mb-3"
                        >
                            {{ "COMMON.APPLY_NOW" | translate }}
                        </button>
                    </div>
                </ng-container>
            </div>
            <!-- View more button for mobile -->
            <div
                class="tw-flex tw-justify-center tw-my-5"
                *ngIf="bankProductsList?.length > displayedBankProducts?.length"
            >
                <button
                    (click)="toggleShowMoreBankProducts()"
                    class="tw-border tw-border-[#4B6EEC] tw-rounded-full tw-py-4 tw-px-6 tw-flex tw-items-center tw-gap-2 tw-text-[#4B6EEC] tw-font-semibold"
                >
                    {{ "COMMON.VIEW_MORE" | translate }}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#4B6EEC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </button>
            </div>
        </div>
        <!-- Desktop view without pagination -->
        <div
            class="tw-hidden md:tw-grid md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-6"
        >
            <ng-container
                *ngFor="let element of bankProductsList; let i = index"
            >
                <div
                    class="tw-w-full tw-h-[175px] md:tw-h-[224px] tw-p-2 tw-bg-[#C7EBFF3D] tw-shadow-sm tw-border tw-border-[#6D7A873D] tw-rounded-[10px] tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-3 tw-overflow-hidden"
                    [ngClass]="{
                        'tw-border-[#4B6EEC]':
                            clickedProduct?.name === element.fiPartnerDescBm &&
                            clickedProduct?.type === 'BANK' &&
                            !dialogClosed,
                        'tw-border-[#D5D5D5]':
                            !(
                                clickedProduct?.name ===
                                    element.fiPartnerDescBm &&
                                clickedProduct?.type === 'BANK'
                            ) && dialogClosed
                    }"
                >
                    <div
                        class="tw-bg-white tw-rounded-[10px] tw-p-2 tw-h-full tw-max-h-[130px] tw-w-full tw-flex tw-justify-center tw-items-center"
                    >
                        <img
                            [attr.ga-event-id]="
                                element.fiPartnerDescEng +
                                '_banks_card_msmefinancing_click'
                            "
                            ga-event-category="MSME Financing Button"
                            ga-event-label="Banks Card Click"
                            ga-track="track"
                            [src]="getImgUrl(element?.fiImage)"
                            alt="Banks"
                            class="tw-h-full tw-object-contain"
                        />
                    </div>
                    <button
                        [attr.ga-event-id]="
                            element.fiPartnerDescEng +
                            '_banks_card_msmefinancing_click'
                        "
                        ga-event-category="MSME Financing Button"
                        ga-event-label="Banks Card Click"
                        ga-track="track"
                        (click)="openProducts(element, 'BANK')"
                        class="tw-block tw-mx-auto tw-bg-[#0F3172] tw-text-white tw-rounded-full tw-min-h-[40px] tw-w-full tw-mb-1 md:tw-mb-3"
                    >
                        {{ "COMMON.APPLY_NOW" | translate }}
                    </button>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Digital Banks  blk-->
    <div
        class="tw-mb-10"
        *ngIf="
            showDigitalBanks &&
            showDigitalBanksFiltered &&
            digitalBankProductsList?.length
        "
    >
        <p
            class="tw-text-[20px] md:tw-text-[30px] tw-w-full tw-text-[#0F3172] tw-font-semibold"
        >
            {{ "COMMON.DIGITAL_BANKS" | translate }}
        </p>
        <!-- Mobile view with pagination -->
        <div class="md:tw-hidden">
            <div class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 tw-gap-6">
                <ng-container
                    *ngFor="
                        let element of digitalBankProductsList;
                        let i = index
                    "
                >
                    <div
                        class="tw-w-full tw-h-[175px] md:tw-h-[224px] tw-p-2 tw-bg-[#C7EBFF3D] tw-shadow-sm tw-border tw-border-[#6D7A873D] tw-rounded-[10px] tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-3 tw-overflow-hidden"
                        [ngClass]="{
                            'tw-border-[#4B6EEC]':
                                clickedProduct?.name ===
                                    element.fiPartnerDescBm &&
                                clickedProduct?.type === 'DIGITAL BANK' &&
                                !dialogClosed,
                            'tw-border-[#D5D5D5]':
                                !(
                                    clickedProduct?.name ===
                                        element.fiPartnerDescBm &&
                                    clickedProduct?.type === 'DIGITAL BANK'
                                ) && dialogClosed
                        }"
                    >
                        <div
                            class="tw-bg-white tw-rounded-[10px] tw-p-2 tw-h-full tw-max-h-[130px] tw-w-full tw-flex tw-justify-center tw-items-center"
                        >
                            <img
                                [attr.ga-event-id]="
                                    element.fiPartnerDescEng +
                                    '_banks_card_msmefinancing_click'
                                "
                                ga-event-category="MSME Financing Button"
                                ga-event-label="Banks Card Click"
                                ga-track="track"
                                [src]="getImgUrl(element?.fiImage)"
                                alt="Banks"
                                class="tw-h-full tw-object-contain"
                            />
                        </div>
                        <button
                            [attr.ga-event-id]="
                                element.fiPartnerDescEng +
                                '_banks_card_msmefinancing_click'
                            "
                            ga-event-category="MSME Financing Button"
                            ga-event-label="Banks Card Click"
                            ga-track="track"
                            (click)="openProducts(element, 'DIGITAL BANK')"
                            class="tw-block tw-mx-auto tw-bg-[#0F3172] tw-text-white tw-rounded-full tw-min-h-[40px] tw-w-full tw-mb-1 md:tw-mb-3"
                        >
                            {{ "COMMON.APPLY_NOW" | translate }}
                        </button>
                    </div>
                </ng-container>
            </div>
            <!-- View more button for mobile -->
            <div
                class="tw-flex tw-justify-center tw-my-5"
                *ngIf="
                    digitalBankProductsList?.length >
                    displayedDigitalBankProducts?.length
                "
            >
                <button
                    (click)="toggleShowMoreDigitalBankProducts()"
                    class="tw-border tw-border-[#4B6EEC] tw-rounded-full tw-py-4 tw-px-6 tw-flex tw-items-center tw-gap-2 tw-text-[#4B6EEC] tw-font-semibold"
                >
                    {{ "COMMON.VIEW_MORE" | translate }}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#4B6EEC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </button>
            </div>
        </div>
        <!-- Desktop view without pagination -->
        <div
            class="tw-hidden md:tw-grid md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-6"
        >
            <ng-container
                *ngFor="let element of digitalBankProductsList; let i = index"
            >
                <div
                    class="tw-w-full tw-h-[175px] md:tw-h-[224px] tw-p-2 tw-bg-[#C7EBFF3D] tw-shadow-sm tw-border tw-border-[#6D7A873D] tw-rounded-[10px] tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-3 tw-overflow-hidden"
                    [ngClass]="{
                        'tw-border-[#4B6EEC]':
                            clickedProduct?.name === element.fiPartnerDescBm &&
                            clickedProduct?.type === 'DIGITAL BANK' &&
                            !dialogClosed,
                        'tw-border-[#D5D5D5]':
                            !(
                                clickedProduct?.name ===
                                    element.fiPartnerDescBm &&
                                clickedProduct?.type === 'DIGITAL BANK'
                            ) && dialogClosed
                    }"
                >
                    <div
                        class="tw-bg-white tw-rounded-[10px] tw-p-2 tw-h-full tw-max-h-[130px] tw-w-full tw-flex tw-justify-center tw-items-center"
                    >
                        <img
                            [attr.ga-event-id]="
                                element.fiPartnerDescEng +
                                '_banks_card_msmefinancing_click'
                            "
                            ga-event-category="MSME Financing Button"
                            ga-event-label="Banks Card Click"
                            ga-track="track"
                            [src]="getImgUrl(element?.fiImage)"
                            alt="Banks"
                            class="tw-h-full tw-object-contain"
                        />
                    </div>
                    <button
                        [attr.ga-event-id]="
                            element.fiPartnerDescEng +
                            '_banks_card_msmefinancing_click'
                        "
                        ga-event-category="MSME Financing Button"
                        ga-event-label="Banks Card Click"
                        ga-track="track"
                        (click)="openProducts(element, 'DIGITAL BANK')"
                        class="tw-block tw-mx-auto tw-bg-[#0F3172] tw-text-white tw-rounded-full tw-min-h-[40px] tw-w-full tw-mb-1 md:tw-mb-3"
                    >
                        {{ "COMMON.APPLY_NOW" | translate }}
                    </button>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Alternate Financing blk -->
    <div
        *ngIf="
            showAlternateFinancing &&
            showAlternateFinancingFiltered &&
            p2pProductsList?.length
        "
    >
        <p
            class="tw-py-2 tw-text-[20px] md:tw-text-[30px] tw-w-full tw-text-[#0F3172] tw-font-semibold"
        >
            {{ "COMMON.ALTERNATE_FINANCING" | translate }}
        </p>

        <!-- Mobile view with pagination -->
        <div class="md:tw-hidden">
            <div class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 tw-gap-6">
                <ng-container
                    *ngFor="let element of displayedP2PProducts; let i = index"
                >
                    <div
                        class="tw-w-full tw-h-[175px] md:tw-h-[224px] tw-p-2 tw-bg-[#C7EBFF3D] tw-shadow-sm tw-border tw-border-[#6D7A873D] tw-rounded-[10px] tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-3 tw-overflow-hidden"
                        [ngClass]="{
                            'tw-border-[#4B6EEC]':
                                clickedProduct?.name ===
                                    element.fiPartnerDescBm &&
                                clickedProduct?.type === 'P2P' &&
                                !dialogClosed,
                            'tw-border-[#D5D5D5]':
                                !(
                                    clickedProduct?.name ===
                                        element.fiPartnerDescBm &&
                                    clickedProduct?.type === 'P2P'
                                ) && dialogClosed
                        }"
                    >
                        <div
                            class="tw-bg-white tw-rounded-[10px] tw-p-2 tw-h-full tw-max-h-[130px] tw-w-full tw-flex tw-justify-center tw-items-center"
                        >
                            <img
                                [attr.ga-event-id]="
                                    element.fiPartnerDescEng +
                                    ga_event[0].alternateFinancing.id
                                "
                                [attr.ga-event-category]="ga_event[0].category"
                                ga-event-label="Alternate Financing Card Click"
                                ga-track="track"
                                [src]="getImgUrl(element?.fiImage)"
                                alt="Funding Societies"
                                class="tw-h-full tw-object-contain"
                            />
                        </div>
                        <button
                            [attr.ga-event-id]="
                                element.fiPartnerDescEng +
                                ga_event[0].alternateFinancing.id
                            "
                            [attr.ga-event-category]="ga_event[0].category"
                            ga-event-label="Alternate Financing Card Click"
                            ga-track="track"
                            (click)="openProducts(element, 'P2P')"
                            class="tw-block tw-mx-auto tw-bg-[#0F3172] tw-text-white tw-rounded-full tw-min-h-[40px] tw-w-full tw-mb-1 md:tw-mb-3"
                        >
                            {{ "COMMON.APPLY_NOW" | translate }}
                        </button>
                    </div>
                </ng-container>
            </div>
            <!-- View more button for mobile -->
            <div
                class="tw-flex tw-justify-center tw-my-5"
                *ngIf="p2pProductsList?.length > displayedP2PProducts?.length"
            >
                <button
                    (click)="toggleShowMoreP2PProducts()"
                    class="tw-border tw-border-[#4B6EEC] tw-rounded-full tw-py-4 tw-px-6 tw-flex tw-items-center tw-gap-2 tw-text-[#4B6EEC] tw-font-semibold"
                >
                    {{ "COMMON.VIEW_MORE" | translate }}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#4B6EEC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </button>
            </div>
        </div>
        <!-- Desktop view without pagination -->
        <div
            class="tw-hidden md:tw-grid md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-6"
        >
            <ng-container
                *ngFor="let element of p2pProductsList; let i = index"
            >
                <div
                    class="tw-w-full tw-h-[175px] md:tw-h-[224px] tw-p-2 tw-bg-[#C7EBFF3D] tw-shadow-sm tw-border tw-border-[#6D7A873D] tw-rounded-[10px] tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-3 tw-overflow-hidden"
                    [ngClass]="{
                        'tw-border-[#4B6EEC]':
                            clickedProduct?.name === element.fiPartnerDescBm &&
                            clickedProduct?.type === 'P2P' &&
                            !dialogClosed,
                        'tw-border-[#D5D5D5]':
                            !(
                                clickedProduct?.name ===
                                    element.fiPartnerDescBm &&
                                clickedProduct?.type === 'P2P'
                            ) && dialogClosed
                    }"
                >
                    <div
                        class="tw-bg-white tw-rounded-[10px] tw-p-2 tw-h-full tw-max-h-[130px] tw-w-full tw-flex tw-justify-center tw-items-center"
                    >
                        <img
                            [attr.ga-event-id]="
                                element.fiPartnerDescEng +
                                ga_event[0].alternateFinancing.id
                            "
                            [attr.ga-event-category]="ga_event[0].category"
                            ga-event-label="Alternate Financing Card Click"
                            ga-track="track"
                            [src]="getImgUrl(element?.fiImage)"
                            alt="Funding Societies"
                            class="tw-h-full tw-object-contain"
                        />
                    </div>
                    <button
                        [attr.ga-event-id]="
                            element.fiPartnerDescEng +
                            ga_event[0].alternateFinancing.id
                        "
                        [attr.ga-event-category]="ga_event[0].category"
                        ga-event-label="Alternate Financing Card Click"
                        ga-track="track"
                        (click)="openProducts(element, 'P2P')"
                        class="tw-block tw-mx-auto tw-bg-[#0F3172] tw-text-white tw-rounded-full tw-min-h-[40px] tw-w-full tw-mb-1 md:tw-mb-3"
                    >
                        {{ "COMMON.APPLY_NOW" | translate }}
                    </button>
                </div>
            </ng-container>
        </div>
    </div>
</section>
